<!-- Page banner Area -->
<div class="page-banner bg-3">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-content">
                    <h2>Privacy Policy</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Privacy Policy</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Page banner Area -->

<!-- Privacy Policy Area -->
<div class="container-fluid mt-5 mb-5">
    <div class="">
        <div class="privacy-policy-text">
            <h2>Our Commitment to Your Privacy</h2>
            <p>At Lemonmode, we take your privacy seriously. This Privacy Policy explains how we collect, use, protect, and share your personal information when you use our logistics and shipping services. We are committed to maintaining the highest standards of data protection and ensuring your personal information remains secure while providing you with seamless global shipping solutions.</p>
            <p>By accessing our website or using our services, you consent to the practices described in this Privacy Policy. We encourage you to read this document carefully to understand how we handle your data and what rights you have regarding your personal information.</p>
            <h2>Information We Collect</h2>
            <p>We collect various types of information to provide and improve our shipping services. This includes personal details such as your name, email address, phone number, billing address, and shipping addresses. We also collect shipment-related information including package dimensions, weight, contents description, tracking numbers, and delivery preferences.</p>
            <p>Additionally, we automatically collect certain technical information when you visit our website, including your IP address, browser type, device information, operating system, and browsing patterns. This helps us optimize our platform performance and enhance your user experience across all devices.</p>
            <h2>How We Use Your Information</h2>
            <p>Your information enables us to process and deliver your shipments efficiently across our global network spanning 120+ countries. We use your data to provide real-time tracking updates, manage customs documentation, coordinate with our carrier partners, and ensure timely delivery of your packages.</p>
            <p>We also use your information to communicate important updates about your shipments, respond to your inquiries, improve our services, and send you relevant marketing communications about new features, service updates, and special offers that may benefit your shipping needs.</p>
            <h2>Data Security and Protection</h2>
            <p>Protecting your data is our top priority. We implement industry-standard security measures including SSL encryption, secure data storage systems, and regular security audits to safeguard your information against unauthorized access, alteration, disclosure, or destruction.</p>
            <p>Our systems are regularly monitored and updated to ensure compliance with international data protection regulations. We limit access to your personal information to authorized employees and trusted partners who need it to provide our services, and all are bound by strict confidentiality agreements.</p>
        </div>
    </div>
</div>
<!-- End Privacy Policy Area -->

<!-- Newsletter Area -->
<div class="newsletter-area">
    <div class="container">
        <div class="newsletter-content">
            <div class="row align-items-center">
                <!-- <div class="col-lg-5 col-md-12">
                    <div class="newsletter-title">
                        <h3>Subscribe to our newsletter:</h3>
                        <p>Focused on the transport and logistic industry</p>
                    </div>
                </div>

                <div class="col-lg-7 col-md-12">
                    <form class="newsletter-form">
                        <input type="email" class="form-control" placeholder="Enter your email" name="EMAIL" required="" autocomplete="off">
                        <button type="submit" class="btn btn-primary">Subscribe</button>
                    </form>
                </div> -->
            </div>
        </div>
    </div>
</div>
<!-- End Newsletter Area -->
